module.exports = __webpack_public_path__ + "img/country-insights-public-holidays.90fb9728.jpg";